// store/balance/useBalanceStore.ts

import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';
import { companiesInitialState, CompaniesState } from './companiesInitialState';
import { CompaniesActions, createCompaniesSlice } from './createCompaniesSlice';

/**
 * @french
 * Hook Zustand persistant pour la gestion des entreprises comptable.
 */
export const useCompaniesStore = create<CompaniesState & CompaniesActions>()(
  persist(combine(companiesInitialState, createCompaniesSlice as any), {
    name: 'companies-store',
  }),
);
